import './Card.css';
import React from 'react';

function Card({title, body, image}) {
    return (
        <div className="card-container">
            <div className="card-content">
                <div className="card-title">
                    <h3>{title}</h3>
                </div>
                <div className="card-body">
                    <p>{body}</p>
                </div>
                <div className="card-image">
                    <img src={image} className="image-icon-link"/>
                </div>
            </div>
            
        </div>
    )
}

export default Card;